import { ChuteStatus } from '@features/SortingSettings/model/sortingSettings';
import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { VITE_APP_SORT_CENTER_API_URL } from '@shared/config/envConfig';

let connection: HubConnection | null = null;

export type ChangeActiveChutePayload = {
    chuteNumber: number;
    status: ChuteStatus
}

export function getSortingCenterHub(): HubConnection {
  if (connection) return connection;

  const HUB_URL = VITE_APP_SORT_CENTER_API_URL + '/sorting-center/shipment-manifest';

  connection = new HubConnectionBuilder()
    .withUrl(HUB_URL, {
      // accessTokenFactory: () => token,
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(LogLevel.Warning)
    .build();

  connection.serverTimeoutInMilliseconds = 40_000; // ждать ответы сервера до 120s
  connection.keepAliveIntervalInMilliseconds = 20_000; // клиентский ping каждые 20s

  return connection;
}

export async function ensureStarted(conn: HubConnection) {
  if (conn.state === HubConnectionState.Connected) return;
  try {
    await conn.start();
  } catch {
    // повторно попробуем через небольшой интервал
    setTimeout(() => ensureStarted(conn), 1500);
  }
}
